import create from "zustand";

export interface ClassroomFeatureFlags {
	[key: string]: boolean;
}

interface State {
	enabledFeatures: ClassroomFeatureFlags;
}

interface Actions {
	setClassroomFeatures: (classroomFeatures: ClassroomFeatureFlags) => void;
	enableFeatures: (features: string[]) => void;
}

export const useFeatureFlagStore = create<State & Actions>((set) => ({
	enabledFeatures: {},
	setClassroomFeatures: (classroomFeatures: ClassroomFeatureFlags) => {
		set(() => ({ enabledFeatures: classroomFeatures }));
	},
	enableFeatures: (features: string[]) => {
		set((state) => {
			const updatedFeatures = { ...state.enabledFeatures };
			features.forEach((feature) => {
				updatedFeatures[feature] = true;
			});
			return { enabledFeatures: updatedFeatures };
		});
	},
}));
